// 初期表示
export const PAGE_INIT = "corp/telecom/trade-press/PAGE_INIT";
// データ初期化
export const DATA_CLEAR = "corp/telecom/trade-press/DATA_CLEAR";
